import { Modal } from '@mantine/core'
import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute, useRouter } from '@tanstack/react-router'
import { useCallback } from 'react'
import { getBookingQueryOptions } from '@/queries/query'
import BookingPriceDetails from '@/components/ui/BookingPriceDetails'
import BankTransferSummary from '@/components/my-booking/booking-detail/BankTransferSummary'

export const Route = createFileRoute('/my-booking/$id/view/payment-detail')({
  component: RouteComponent,
})

function RouteComponent() {
  const router = useRouter()
  const navigate = Route.useNavigate()
  const bookingId = Route.useParams({
    select: (s) => s.id,
  })
  const {
    data: {
      data: { booking },
    },
  } = useSuspenseQuery(getBookingQueryOptions(bookingId))

  const onClose = useCallback(() => {
    if (router.history.canGoBack()) {
      return router.history.back({ ignoreBlocker: true })
    }
    return navigate({
      replace: true,
      to: '/my-booking/$id/view',
      params: {
        id: bookingId,
      },
    })
  }, [router.history, navigate, bookingId])

  return (
    <Modal
      keepMounted={false}
      opened
      title="Payment Details"
      onClose={onClose}
      centered
      radius="lg"
      size="xl"
      styles={{
        content: {
          boxShadow: `
                0px 0px 2px 0px rgba(79, 94, 113, 0.12),
                0px 2px 4px 0px rgba(79, 94, 113, 0.11),
                0px 4px 8px 0px rgba(79, 94, 113, 0.10),
                0px 8px 16px 0px rgba(79, 94, 113, 0.09),
                0px 16px 32px 0px rgba(79, 94, 113, 0.08)
              `,
        },
      }}
      classNames={{
        title: '!text-[22px] !font-bold',
        content: '!pt-5',
        header: '!px-10',
      }}
    >
      <div className="flex flex-col [&_[data-active=true]]:!shadow-none">
        <BookingPriceDetails hideTotalPayable booking={booking} />
        <BankTransferSummary booking={booking} />
      </div>
    </Modal>
  )
}
